"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SelfClosingAlert = _interopRequireDefault(require("./SelfClosingAlert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MessageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertHolder__MessageWrapper",
  componentId: "m63teh-0"
})(["pointer-events:all;position:fixed;text-align:center;width:50%;left:25%;top:75px;z-index:1150;"]);

var Message = _styledComponents["default"].div.withConfig({
  displayName: "AlertHolder__Message",
  componentId: "m63teh-1"
})(["display:inline-block;text-align:left;font-weight:@font-weight-light;font-size:1rem;margin-bottom:0.625rem;"]);

var AlertHolder = function AlertHolder(_ref) {
  var alerts = _ref.alerts,
      onRemove = _ref.onRemove,
      fullWidth = _ref.fullWidth;
  return _react["default"].createElement("div", {
    id: "alert-holder"
  }, alerts && alerts.length > 0 ? _react["default"].createElement(MessageWrapper, null, _react["default"].createElement(Message, {
    style: {
      width: fullWidth ? "95%" : ""
    }
  }, alerts.map(function (alert, index) {
    return _react["default"].createElement(_SelfClosingAlert["default"], {
      key: alert.id || index,
      type: alert.type,
      text: alert.text,
      id: alert.id,
      onRemove: onRemove
    });
  }))) : null);
};

AlertHolder.propTypes = {
  /** alerts to display */
  alerts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    text: _propTypes["default"].string
  })).isRequired,

  /** function for remove */
  onRemove: _propTypes["default"].func.isRequired,

  /** full width of the screen */
  fullWidth: _propTypes["default"].bool
};
AlertHolder.defaultProps = {
  fullWidth: true
};
var _default = AlertHolder;
exports["default"] = _default;